module.exports = __webpack_public_path__ + "img/ys_bj_3.a9742473.png";